module.exports = __webpack_public_path__ + "img/44.c8d85f1c.png";